import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";

// ============================================================================
// Types
// ============================================================================

export interface ConfirmDeleteDialogProps {
	open: boolean;
	title: string;
	message: string;
	confirmLabel?: string;
	cancelLabel?: string;
	onConfirm: () => void;
	onCancel: () => void;
}

// ============================================================================
// Component
// ============================================================================

export function ConfirmDeleteDialog({
	open,
	title,
	message,
	confirmLabel = "Delete",
	cancelLabel = "Cancel",
	onConfirm,
	onCancel,
}: ConfirmDeleteDialogProps) {
	return (
		<Dialog
			open={open}
			onClose={onCancel}
			aria-labelledby="confirm-delete-dialog-title"
			aria-describedby="confirm-delete-dialog-description"
		>
			<DialogTitle id="confirm-delete-dialog-title">{title}</DialogTitle>
			<DialogContent>
				<DialogContentText id="confirm-delete-dialog-description">{message}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel} data-testid="confirm-dialog-cancel">
					{cancelLabel}
				</Button>
				<Button onClick={onConfirm} color="error" variant="contained" autoFocus data-testid="confirm-dialog-confirm">
					{confirmLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
